export default "__VITE_PUBLIC_ASSET__04394802__"